/* =========================================================
   NuAlign clone (nualign-001) — interactions
   header shadow · mobile drawer · scroll reveal · hero gallery
   quantity-tier variant select · AJAX add-to-cart · FAQ · sticky CTA
   All ids namespaced (na-*) to avoid theme collisions.
   ========================================================= */
(function () {
  "use strict";
  var root = document.getElementById("na-root");
  if (!root) return;

  var money = function (cents) {
    try {
      var f = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : "";
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (f ? " " + f : "");
    } catch (e) { return (cents / 100).toFixed(2); }
  };

  /* ---- Dismissible announcement bar (remembered for the session) ---- */
  var announce = document.getElementById("na-announce");
  var announceClose = document.getElementById("na-announceClose");
  if (announce && announceClose) {
    try { if (sessionStorage.getItem("na-announce-dismissed") === "1") announce.classList.add("is-hidden"); } catch (e) {}
    announceClose.addEventListener("click", function () {
      announce.classList.add("is-hidden");
      try { sessionStorage.setItem("na-announce-dismissed", "1"); } catch (e) {}
    });
  }

  /* ---- Header shadow on scroll ---- */
  var header = document.getElementById("na-header");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById("na-drawer");
  var menuToggle = document.getElementById("na-menuToggle");
  var drawerClose = document.getElementById("na-drawerClose");
  if (drawer && menuToggle && drawerClose) {
    var openDrawer = function () { drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); menuToggle.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; };
    var closeDrawer = function () { drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); menuToggle.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; };
    menuToggle.addEventListener("click", openDrawer);
    drawerClose.addEventListener("click", closeDrawer);
    drawer.querySelectorAll("[data-close]").forEach(function (a) { a.addEventListener("click", closeDrawer); });
  }

  /* ---- Content is visible by default (see .reveal in CSS) — no scroll-triggered fade-in on paid mobile traffic. ---- */

  /* ---- Hero gallery thumbnail swap ---- */
  var gMain = document.getElementById("na-galleryMain");
  var gThumbs = root.querySelectorAll("#na-galleryThumbs .gallery__thumb");
  if (gMain && gThumbs.length) {
    gMain.style.transition = "opacity .25s ease";
    gThumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        gThumbs.forEach(function (b) { b.setAttribute("aria-current", "false"); });
        btn.setAttribute("aria-current", "true");
        var img = btn.getAttribute("data-img");
        var label = btn.getAttribute("data-label") || "";
        gMain.style.opacity = "0";
        setTimeout(function () {
          if (img) {
            var mainImg = gMain.querySelector("img.na-img");
            if (mainImg) mainImg.src = img;
          } else if (label) {
            gMain.setAttribute("data-label", label);
          }
          gMain.style.opacity = "1";
        }, 180);
      });
    });
  }

  /* ---- Quantity tiers: select tier + sync qty + savings banner + numeric transition ---- */
  function updateSavings(savingsBox, msg) {
    if (!savingsBox) return;
    savingsBox.textContent = msg || "";
    savingsBox.classList.toggle("visible", !!msg);
    /* restart animation on each change */
    if (msg) { savingsBox.style.animation = "none"; savingsBox.offsetHeight; savingsBox.style.animation = ""; }
  }

  /* Fade the old value out, swap the text, fade the new value in. Respects prefers-reduced-motion (transition is dropped in CSS). */
  function swapNumber(el, newText) {
    if (!el || el.textContent === newText) return;
    el.classList.add("num-swap");
    setTimeout(function () {
      el.textContent = newText;
      el.classList.remove("num-swap");
    }, 140);
  }

  root.querySelectorAll(".tiers").forEach(function (group) {
    var tiers = group.querySelectorAll(".tier");
    var offer = group.closest(".pcard__offer") || group.parentElement;
    var cta = offer ? offer.querySelector(".pcard__cta") : null;
    var ctaTotal = cta ? cta.querySelector(".cta-total") : null;
    var savingsBox = offer ? offer.querySelector("[data-savings-box]") : null;
    var shopPayQty = offer ? offer.querySelector("[data-shoppay-qty]") : null;

    function applyGiftAttrs(tier) {
      if (!cta) return;
      var giftId = tier.getAttribute("data-gift-variant-id");
      var giftQty = tier.getAttribute("data-gift-qty");
      if (giftId) { cta.setAttribute("data-gift-variant-id", giftId); cta.setAttribute("data-gift-qty", giftQty || "1"); }
      else { cta.removeAttribute("data-gift-variant-id"); cta.removeAttribute("data-gift-qty"); }
    }

    /* init savings + gift attrs from default selected tier */
    var defaultTier = group.querySelector(".tier.is-selected") || tiers[0];
    if (defaultTier) { updateSavings(savingsBox, defaultTier.getAttribute("data-savings") || ""); applyGiftAttrs(defaultTier); }

    tiers.forEach(function (tier) {
      tier.addEventListener("click", function () {
        tiers.forEach(function (t) { t.classList.remove("is-selected"); t.setAttribute("aria-checked", "false"); });
        tier.classList.add("is-selected");
        tier.setAttribute("aria-checked", "true");
        if (ctaTotal) swapNumber(ctaTotal, tier.getAttribute("data-total") || ctaTotal.textContent);
        if (cta) {
          cta.setAttribute("data-variant-id", tier.getAttribute("data-variant-id") || "");
          cta.setAttribute("data-qty", tier.getAttribute("data-qty") || "1");
          applyGiftAttrs(tier);
        }
        if (shopPayQty) shopPayQty.value = tier.getAttribute("data-qty") || "1";
        updateSavings(savingsBox, tier.getAttribute("data-savings") || "");
      });
    });
  });

  /* ---- Hero: single-tap upsell toggle (1 unit <-> 2 units). Not a radiogroup like .tiers —
     just one row that flips the hero CTA between the two precomputed, server-rendered totals. ---- */
  var heroUpsell = document.getElementById("na-heroUpsell");
  var heroCta = document.getElementById("na-heroCta");
  if (heroUpsell && heroCta) {
    var heroCtaTotal = heroCta.querySelector(".cta-total");
    var heroShopPayQty = document.querySelector('#na-hero-shoppay-form [data-shoppay-qty]');
    heroUpsell.addEventListener("click", function () {
      var next = heroUpsell.getAttribute("aria-pressed") !== "true";
      heroUpsell.setAttribute("aria-pressed", next ? "true" : "false");
      var qty = next ? (heroUpsell.getAttribute("data-qty") || "2") : "1";
      heroCta.setAttribute("data-qty", qty);
      var total = next ? heroCta.getAttribute("data-total-2") : heroCta.getAttribute("data-total-1");
      if (heroCtaTotal && total) swapNumber(heroCtaTotal, total);
      if (heroShopPayQty) heroShopPayQty.value = qty;
    });
  }

  /* ---- AJAX add-to-cart (supports one free/bundled gift line item via data-gift-variant-id) ---- */
  function addToCart(btn) {
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) { showBtnError(btn, "Select an option first"); return; }
    var quantity = parseInt(btn.getAttribute("data-qty"), 10) || 1;
    var items = [{ id: Number(variantId), quantity: quantity }];
    var giftId = btn.getAttribute("data-gift-variant-id");
    if (giftId) {
      var giftQty = parseInt(btn.getAttribute("data-gift-qty"), 10) || 1;
      items.push({ id: Number(giftId), quantity: giftQty });
    }
    setBtnState(btn, "loading");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function(data) { throw new Error(data.description || "add failed"); });
      return r.json();
    }).then(function () {
      setBtnState(btn, "added");
      /* Single-product store: skip the cart page and go straight to checkout (one step fewer on mobile). */
      setTimeout(function () { window.location.href = "/checkout"; }, 700);
    }).catch(function (err) {
      setBtnState(btn, "");
      showBtnError(btn, err && err.message && err.message !== "add failed" ? err.message : "Couldn't add to cart — try again");
    });
  }

  /* Add to cart -> spinner -> Added (checkmark) -> back to normal. Removes the "did it work?" doubt before redirecting to checkout. */
  function setBtnState(btn, state) {
    if (!btn) return;
    if (!btn.querySelector(".btn__label")) {
      btn.innerHTML = '<span class="btn__label">' + btn.innerHTML + '</span>'
        + '<span class="btn__spinner"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M21 12a9 9 0 1 1-3-6.7"/></svg></span>'
        + '<span class="btn__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M5 12l5 5L20 6"/></svg> Added</span>';
    }
    if (state) btn.setAttribute("data-cart-state", state); else btn.removeAttribute("data-cart-state");
  }

  function showBtnError(btn, msg) {
    if (!btn) return;
    var label = btn.querySelector(".btn__label");
    var target = label || btn;
    var saved = target.innerHTML;
    var savedBg = btn.style.background;
    target.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" width="16" height="16"><path d="M6 6l12 12M18 6L6 18"/></svg> ' + msg;
    btn.style.background = "var(--clay)";
    setTimeout(function () { target.innerHTML = saved; btn.style.background = savedBg; }, 3500);
  }

  root.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      addToCart(btn);
    });
  });

  /* ---- FAQ accordion (single-open) ---- */
  var faqItems = root.querySelectorAll(".faq__item");
  faqItems.forEach(function (item) {
    var q = item.querySelector(".faq__q");
    var a = item.querySelector(".faq__a");
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var isOpen = item.classList.contains("open");
      faqItems.forEach(function (other) {
        if (other !== item) {
          other.classList.remove("open");
          var oq = other.querySelector(".faq__q"); var oa = other.querySelector(".faq__a");
          if (oq) oq.setAttribute("aria-expanded", "false");
          if (oa) oa.style.maxHeight = null;
        }
      });
      if (isOpen) { item.classList.remove("open"); q.setAttribute("aria-expanded", "false"); a.style.maxHeight = null; }
      else { item.classList.add("open"); q.setAttribute("aria-expanded", "true"); a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });

  /* ---- Sticky mobile CTA after hero ---- */
  var sticky = document.getElementById("na-stickyCta");
  var hero = root.querySelector(".hero");
  if ("IntersectionObserver" in window && hero && sticky) {
    var heroIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top < 0) sticky.classList.add("show");
        else sticky.classList.remove("show");
      });
    }, { threshold: 0 });
    heroIo.observe(hero);
  }
})();
